/* Cart terms and conditions */
(function () {
  const STORAGE_KEY = 'cart_terms_accepted';
  const CHECKBOX_SELECTOR = '[data-cart-terms]';
  const ALERT_SELECTOR = '[data-cart-terms-alert]';

  function getAccepted() {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  }

  function setAccepted(accepted) {
    localStorage.setItem(STORAGE_KEY, accepted ? 'true' : 'false');
  }

  function getCheckboxes() {
    return document.querySelectorAll(CHECKBOX_SELECTOR);
  }

  function restoreCheckboxes() {
    const accepted = getAccepted();
    getCheckboxes().forEach(function (checkbox) {
      checkbox.checked = accepted;
    });
  }

  function syncCheckboxes(source) {
    const accepted = source.checked;
    setAccepted(accepted);
    getCheckboxes().forEach(function (checkbox) {
      if (checkbox !== source) {
        checkbox.checked = accepted;
      }
    });
  }

  function getAlertMessage() {
    const el = document.querySelector(ALERT_SELECTOR);
    return el ? el.getAttribute('data-cart-terms-alert') : '';
  }

  function isTermsRequired() {
    return getCheckboxes().length > 0;
  }

  function isCheckoutTrigger(target) {
    if (!target || !target.closest) return false;

    const checkoutBtn = target.closest('button[name="checkout"], input[name="checkout"]');
    if (checkoutBtn) return true;

    if (target.closest('.additional-checkout-buttons')) return true;

    return false;
  }

  function onChange(event) {
    const checkbox = event.target.closest(CHECKBOX_SELECTOR);
    if (!checkbox) return;
    syncCheckboxes(checkbox);
  }

  function onClick(event) {
    if (!isTermsRequired()) return;
    if (!isCheckoutTrigger(event.target)) return;
    if (getAccepted()) return;

    event.preventDefault();
    event.stopPropagation();

    const message = getAlertMessage();
    if (message) {
      alert(message);
    }
  }

  function init() {
    restoreCheckboxes();

    document.addEventListener('change', onChange);
    document.addEventListener('click', onClick, true);

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
        requestAnimationFrame(restoreCheckboxes);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* end Cart terms and conditions */

/* PLP fake-variant swatch tooltips */
(function () {
  const ROW = '.product-card__swatches--variant-products';
  const TOOLTIP_HOST = ROW + ' [data-tooltip]';
  const DETACHED_CLASS = 'is-detached';
  const EDGE_PADDING = 8;
  // Matches the theme's own inset-block-end: calc(100% + 1.5rem) gap.
  const TOOLTIP_GAP = 15;

  // .tooltip is centred on its tile with no awareness of the viewport, so a
  // tile in the last grid column pushes the bubble off-screen where it gets
  // clipped. Nudge it back and let the CSS counter-shift the arrow so it keeps
  // pointing at the tile.
  const finePointer = window.matchMedia('(pointer: fine)');

  function hasTransformedAncestor(element) {
    let node = element.parentElement;
    while (node && node !== document.body) {
      const style = getComputedStyle(node);
      if (style.transform !== 'none' || style.filter !== 'none' ||
          style.perspective !== 'none' || style.willChange === 'transform') {
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function clampToViewport(event) {
    // The theme only reveals the styled tooltip under (pointer: fine).
    if (!finePointer.matches) return;
    if (!event.target || !event.target.closest) return;

    const host = event.target.closest(TOOLTIP_HOST);
    if (!host) return;

    const tooltip = host.querySelector('.tooltip');
    if (!tooltip) return;

    // Measure unshifted. offsetWidth is used rather than getBoundingClientRect
    // because the resting scale(0.85) would otherwise under-report the width.
    tooltip.classList.remove(DETACHED_CLASS);
    tooltip.style.removeProperty('--tooltip-shift');
    tooltip.style.removeProperty('left');
    tooltip.style.removeProperty('top');

    const hostRect = host.getBoundingClientRect();
    const centre = hostRect.left + hostRect.width / 2;
    const half = tooltip.offsetWidth / 2;
    const viewport = document.documentElement.clientWidth;

    let shift = 0;

    const overflowRight = centre + half - (viewport - EDGE_PADDING);
    if (overflowRight > 0) shift = -overflowRight;

    const overflowLeft = EDGE_PADDING - (centre - half + shift);
    if (overflowLeft > 0) shift += overflowLeft;

    // A carousel row scrolls, and a scroll box clips on BOTH axes — the bubble
    // sits above the row, so it would be cut off entirely. Detaching it to
    // position: fixed escapes the scroll box, but only if there are no
    // transformed ancestors (transform/filter/perspective make fixed position
    // relative to that ancestor, not the viewport).
    const row = host.closest(ROW);
    const rowScrolls = row && getComputedStyle(row).overflowX !== 'visible';

    if (rowScrolls && !hasTransformedAncestor(tooltip)) {
      tooltip.classList.add(DETACHED_CLASS);
      // left is the tile's centre, not the bubble's edge: the theme's
      // translate(-50%) still applies and does the centring, which also keeps
      // the reveal transform (and its scale) intact.
      tooltip.style.left = Math.round(centre + shift) + 'px';
      tooltip.style.top = Math.round(hostRect.top - tooltip.offsetHeight - TOOLTIP_GAP) + 'px';
    }

    if (shift !== 0) {
      // In RTL, inline-start maps to the physical right edge, so invert the
      // shift sign so a negative physical offset still moves the tooltip left.
      const isRtl = getComputedStyle(tooltip).direction === 'rtl';
      const correctedShift = isRtl ? -shift : shift;
      tooltip.style.setProperty('--tooltip-shift', Math.round(correctedShift) + 'px');
    }
  }

  document.addEventListener('pointerover', clampToViewport, { passive: true });
})();
/* end PLP fake-variant swatch tooltips */
